import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/welcome/welcome1.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 text-white welcome-box" }
const _hoisted_2 = { class: "card-body pe-15 pe-sm-20 pe-md-0 pb-0 pt-15 pt-sm-20" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-8 col-md-8" }
const _hoisted_5 = { class: "title position-relative" }
const _hoisted_6 = { class: "fw-semibold mb-8 mt-15 text-white" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "ps-0 mt-20 mb-20 text-white" }
const _hoisted_9 = { class: "d-block fw-black lh-1 mt-5 mt-md-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, [
              _cache[0] || (_cache[0] = _createTextVNode(" Bonjour, ", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userName ? _ctx.userName : ""), 1)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "d-block text-white fs-md-15 fs-lg-16" }, " Voici ce qui se passe dans votre agence aujourd’hui ", -1))
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.soldes, (sol, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "d-inline-block text-uppercase fw-medium fs-13 position-relative"
              }, [
                _createTextVNode(" Total " + _toDisplayString(sol.RedStatut == "Payée" ? " Réabonnnement" : sol.RedStatut == "En attente" ? "Redevance" : sol.RedStatut) + " ", 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatMontant(sol.Montant)), 1)
              ]))
            }), 128))
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-4 col-md-4 text-center mt-15 mt-md-0" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "welcome-image"
          })
        ], -1))
      ])
    ])
  ]))
}